import React, { useEffect, useState } from "react";
import "./Cards.css";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import {
  getdistictName,
  getAllBlocksFromDistrict,
  school_name_block_wise,
  get_hostel_type_from_udise,
  getAmenitiesType,
  AllStaff,
  getAllStudents,
  getSchoolData,
  getHostelData,
} from "../../api/Users";

import Map from "../Map/Map";
import HighchartsReact from "highcharts-react-official";
import Spinner from "../Loader/Spinner";
import Highcharts from "highcharts";
import { toast } from "react-toastify";

const SchoolCards = (props) => {
  console.log(props);
  const { t } = useTranslation();

  const [DistrictName, setDistrictName] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [District, setDistrict] = useState("");
  const [Allblocks, setAllBlocks] = useState([]);
  const [SchoolName, setSchoolName] = useState("");
  const [Block, setBlock] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [AllHostelTypes, setAllHostelTypes] = useState([]);
  const [hostelId, setHostelId] = useState("");
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [AssetsType, setAssetsType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [students, setStudents] = useState(0);
  const [staffcount, setStaffCount] = useState(0);
  const [allHostels, setAllHostels] = useState([]);
  const [hostelWiseStudents, setHostelWiseStudents] = useState([]);
  const [hostelWiseStaff, setHostelWiseStaff] = useState([]);
  const [schools, setSchools] = useState([]);
  const [hostels, setHostels] = useState(0);
  const [staffData, setStaffData] = useState({
    male: 0,
    female: 0,
    teaching: 0,
    non_teaching: 0,
  });
  const [staffOptions, setStaffOptions] = useState();
  const [otherStaffOptions, setOtherStaffOptions] = useState();
  const [girlsBoysOptions, setGirlsBoysOptions] = useState();
  const [categoryOptions, setCategoryOptions] = useState();
  const [resOptions, setResOptions] = useState();
  const [schoolTypeOptions, setSchoolTypeOptions] = useState();
  const [hostel1Options, setHostel1Options] = useState();
  const [hostel2Options, setHostel2Options] = useState();

  const [staffOptionsCheck, setStaffOptionsCheck] = useState(true);
  const [otherStaffOptionsCheck, setOtherStaffOptionsCheck] = useState(true);
  const [girlsBoysOptionsCheck, setGirlsBoysOptionsCheck] = useState(true);
  const [categoryOptionsCheck, setCategoryOptionsCheck] = useState(true);
  const [resOptionsCheck, setResOptionsCheck] = useState(true);
  const [schoolTypeOptionsCheck, setSchoolTypeOptionsCheck] = useState(true);
  const [hostel1OptionsCheck, setHostel1OptionsCheck] = useState(true);
  const [hostel2OptionsCheck, setHostel2OptionsCheck] = useState(true);

  useEffect(() => {
    getSchoolCardsData();
  }, []);

  const getSchoolCardsData = () => {
    const data =
      props.role == 4
        ? {
            role_id: 4,
            school_id: props.userData.school_id,
          }
        : props.role == 5
        ? {
            role_id: 5,
            district_code: props.userData.district_code,
            block_code: props.userData.block_code,
            school_id: schoolId === "" ? "all" : schoolId,
          }
        : props.role == 6 || props.role == 7
        ? {
            role_id: props.role == 6 ? 6 : 7,
            district_code: props.userData.district_code,
            block_code: Block === "" ? "all" : Block,
            school_id: schoolId === "" ? "all" : schoolId,
          }
        : {
            role_id: 8,
            district_code: District === "" ? "all" : District,
            block_code: Block === "" ? "all" : Block,
            school_id: schoolId === "" ? "all" : schoolId,
          };

    getAllStudents(data)
      .then((res) => {
        setStudents(res.total_students[0].count);
        const options = {
          chart: {
            type: "pie",
            backgroundColor: "transparent",
          },
          title: {
            text: `<span style="font-size: 50px; font-weight: 500">${
              res.no_of_boys[0].male + res.no_of_girls[0].female
            }</span>
            <br>${t("Total")}`,
            verticalAlign: "middle",
            y: 45,
            x: 0,
            style: {
              fontSize: "20px",
            },
          },
          plotOptions: {
            pie: {
              size: "55%",
              innerSize: "80%",
            },
          },
          series: [
            {
              name: t("Total"),
              data: [
                {
                  name: "Number of Boys: " + res.no_of_boys[0].male,
                  y: res.no_of_boys[0].male,
                  color: "Blue",
                },
                {
                  name: "Number of girls: " + res.no_of_girls[0].female,
                  y: res.no_of_girls[0].female,
                  color: "lightgreen",
                },
              ],
            },
          ],
        };
        setGirlsBoysOptions(options);
        setGirlsBoysOptionsCheck(false);

        const options2 = {
          chart: {
            type: "pie",
            backgroundColor: "transparent",
          },
          title: {
            text: `<span style="font-size: 50px; font-weight: 500">${
              res.caste_category.ST.Male +
              res.caste_category.ST.Female +
              res.caste_category.SC.Male +
              res.caste_category.SC.Female +
              res.caste_category.OC.Male +
              res.caste_category.OC.Female
            }</span>
            <br>${t("Total")}`,
            verticalAlign: "middle",
            y: 45,
            x: 0,
            style: {
              fontSize: "20px",
            },
          },
          plotOptions: {
            pie: {
              size: "55%",
              innerSize: "80%",
            },
          },
          series: [
            {
              name: t("Total"),
              data: [
                {
                  name:
                    "ST: " +
                    (res.caste_category.ST.Male + res.caste_category.ST.Female),
                  y: res.caste_category.ST.Male + res.caste_category.ST.Female,
                  color: "Blue",
                },
                {
                  name:
                    "SC: " +
                    (res.caste_category.SC.Male + res.caste_category.SC.Female),
                  y: res.caste_category.SC.Male + res.caste_category.SC.Female,
                  color: "lightgreen",
                },
                {
                  name:
                    "OC: " +
                    (res.caste_category.OC.Male + res.caste_category.OC.Female),
                  y: res.caste_category.OC.Male + res.caste_category.OC.Female,
                  color: "red",
                },
              ],
            },
          ],
        };
        setCategoryOptions(options2);
        setCategoryOptionsCheck(false);
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });

    AllStaff(data)
      .then((res) => {
        setStaffCount(res.male_count + res.female_count);
        setStaffData({
          male: res.male_count,
          female: res.female_count,
          teaching: res.teaching_staff,
          non_teaching: res.non_teaching_staff,
        });

        const options = {
          chart: {
            type: "pie",
            backgroundColor: "transparent",
          },
          title: {
            text: `<span style="font-size: 50px; font-weight: 500">${
              res.male_count + res.female_count
            }</span>
            <br>${t("Total")}`,
            verticalAlign: "middle",
            y: 45,
            x: 0,
            style: {
              fontSize: "20px",
            },
          },
          plotOptions: {
            pie: {
              size: "55%",
              innerSize: "80%",
            },
          },
          series: [
            {
              name: t("Total"),
              data: [
                {
                  name: "Male: " + res.male_count,
                  y: res.male_count,
                  color: "Blue",
                },
                {
                  name: "Female: " + res.female_count,
                  y: res.female_count,
                  color: "lightgreen",
                },
              ],
            },
          ],
        };
        setStaffOptions(options);
        setStaffOptionsCheck(false);

        const options2 = {
          chart: {
            type: "pie",
            backgroundColor: "transparent",
          },
          title: {
            text: `<span style="font-size: 50px; font-weight: 500">${
              res.teaching_staff + res.non_teaching_staff
            }</span>
            <br>${t("Total")}`,
            verticalAlign: "middle",
            y: 45,
            x: 0,
            style: {
              fontSize: "20px",
            },
          },
          plotOptions: {
            pie: {
              size: "55%",
              innerSize: "80%",
            },
          },
          series: [
            {
              name: t("Total"),
              data: [
                {
                  name: "Teaching staff: " + res.teaching_staff,
                  y: res.teaching_staff,
                  color: "Blue",
                },
                {
                  name: "Non Teaching Staff: " + res.non_teaching_staff,
                  y: res.non_teaching_staff,
                  color: "red",
                },
              ],
            },
          ],
        };
        setOtherStaffOptions(options2);
        setOtherStaffOptionsCheck(false);

        getSchoolData(data)
          .then((res) => {
            setSchools(res.data[0].total_school);

            const options = {
              chart: {
                type: "pie",
                backgroundColor: "transparent",
              },
              title: {
                text: ``,
              },
              plotOptions: {
                pie: {
                  size: "55%",
                },
              },
              series: [
                {
                  name: t("Total"),
                  data: [
                    {
                      name:
                        "Total Residential Schools: " +
                        res.data[0].total_residential_schools,
                      y: res.data[0].total_residential_schools,
                      color: "Blue",
                    },
                    {
                      name:
                        "Total Non-residential Schools: " +
                        res.data[0].total_non_residential_schools,
                      y: res.data[0].total_non_residential_schools,
                      color: "lightgreen",
                    },
                  ],
                },
              ],
            };
            setResOptions(options);
            setResOptionsCheck(false);

            const options2 = {
              chart: {
                type: "pie",
                backgroundColor: "transparent",
              },
              title: {
                text: ``,
              },
              plotOptions: {
                pie: {
                  size: "55%",
                  innerSize: "50%",
                },
              },
              series: [
                {
                  name: t("Total"),
                  data: [
                    {
                      name: "SSD: " + res.data[0].total_school,
                      y: res.data[0].total_school,
                      color: "Blue",
                    },
                    {
                      name: "ANWESHA: 0",
                      y: 0,
                      color: "lightgreen",
                    },
                    {
                      name: "S&ME: 0",
                      y: 0,
                      color: "red",
                    },
                  ],
                },
              ],
            };
            setSchoolTypeOptions(options2);
            setSchoolTypeOptionsCheck(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            toast.error(t("Something went wrong"));
          });

        getHostelData(data)
          .then((res) => {
            setHostels(res.data[0].total_hostel);

            const options = {
              chart: {
                type: "pie",
                backgroundColor: "transparent",
              },
              title: {
                text: `<span style="font-size: 30px; font-weight: 500">${
                  res.data[0].total_sme_hostels +
                  res.data[0].total_ssd_hostels +
                  res.data[0].total_anwesha_hostels
                }</span>
                <br>${t("Total")}`,
                verticalAlign: "middle",
                y: 30,
                x: 0,
                style: {
                  fontSize: "20px",
                },
              },
              plotOptions: {
                pie: {
                  size: "55%",
                  innerSize: "50%",
                },
              },
              series: [
                {
                  name: t("Total"),
                  data: [
                    {
                      name:
                        "Total S&ME Hostels: " + res.data[0].total_sme_hostels,
                      y: res.data[0].total_sme_hostels,
                      color: "Blue",
                    },
                    {
                      name:
                        "Total SSD Hostels: " + res.data[0].total_ssd_hostels,
                      y: res.data[0].total_ssd_hostels,
                      color: "lightgreen",
                    },
                    {
                      name:
                        "Total ANWESHA Hostels: " +
                        res.data[0].total_anwesha_hostels,
                      y: res.data[0].total_anwesha_hostels,
                      color: "red",
                    },
                  ],
                },
              ],
            };
            setHostel1Options(options);
            setHostel1OptionsCheck(false);

            const options2 = {
              chart: {
                type: "pie",
                backgroundColor: "transparent",
              },
              title: {
                text: ``,
              },
              plotOptions: {
                pie: {
                  size: "55%",
                  innerSize: "50%",
                },
              },
              series: [
                {
                  name: t("Total"),
                  data: [
                    {
                      name:
                        "Total 100-Capacity Hostels: " +
                        res.data[0].total_capacity_100,
                      y: res.data[0].total_capacity_100,
                      color: "Blue",
                    },
                    {
                      name:
                        "Total 200-Capacity Hostels: " +
                        res.data[0].total_capacity_200,
                      y: res.data[0].total_capacity_200,
                      color: "lightgreen",
                    },
                    {
                      name:
                        "Total 300-Capacity Hostels: " +
                        res.data[0].total_capacity_300,
                      y: res.data[0].total_capacity_300,
                      color: "orange",
                    },
                    {
                      name:
                        "Total 500-Capacity Hostels: " +
                        res.data[0].total_capacity_500,
                      y: res.data[0].total_capacity_500,
                      color: "aqua",
                    },
                    {
                      name:
                        "Total Other Hostels: " +
                        res.data[0].total_others_capacity,
                      y: res.data[0].total_others_capacity,
                      color: "red",
                    },
                  ],
                },
              ],
            };
            setHostel2Options(options2);
            setHostel2OptionsCheck(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            toast.error(t("Something went wrong"));
          });
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    // const StaffCountData = props.role === 4 || {
    //   school_id: props.userData.school_id,
    // };

    // AllStaff(StaffCountData)
    //   .then((res) => {
    //     setStaffCount(res.data[0].total);
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error);
    //     toast.error(t("Something went wrong"));
    //     setIsLoading(false);
    //   });
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    getDistictNames();

    if (props.role == 6 || props.role == 7) {
      getAllBlocksFromDistrict(props.userData.district_code).then((res) => {
        if (res.status == "success") {
          setAllBlocks(res.data.new_asset_query);
        } else {
          setAllBlocks([]);
        }
      });
    }

    if (props.role == 5) {
      const data = {
        block_code: props.userData.block_code,
      };
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }

    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          setAssetsTypes(res.data.assets_name);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);
    setAllBlocks([]);
    setAllSchoolNames([]);
    setAllHostelTypes([]);
    setAssetsType("");
    setBlock("");
    setSchoolId("");

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
  };

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    setAllSchoolNames([]);
    setAllHostelTypes([]);
    setAssetsType("");
    setSchoolId("");

    const data = {
      block_code: e.target.value,
    };
    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  const handleSchoolName = (e) => {
    try {
      setSchoolId(e.target.value);
      setAllHostelTypes([]);
      setAssetsType("");
      console.log(props.userData);

      const data = {
        UDISE_code: props.userData.UDISE_code,
      };

      get_hostel_type_from_udise(data).then((res) => {
        if (res.status == "success") {
          setAllHostelTypes(res.data.hostelData);
        } else {
          setAllHostelTypes([]);
        }
      });
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };

  const renderChart = (options, isEmpty) => {
    if (isLoading) {
      return <Spinner />;
    } else if (isEmpty) {
      return (
        <div className="col-sm-12 col-md-12 mb-4">
          <div className="">
            <div className=" p-5">
              <h5 className="card-title text-center">{t("No data found")}</h5>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-sm-12 col-md-12 mb-4">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      );
    }
  };

  return (
    <div className="row">
      <div className="row justify-content-between mb-3">
        <div className="col-6 d-flex align-items-center">
          <h3 className="fs-4 mt-4">{t("School")}</h3>
        </div>
        <div className="col-6 d-flex align-items-center justify-content-end">
          {props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label htmlFor="title" className="form-label">
                {t("District")}
              </label>
              <select
                name="asset_sub_type"
                onChange={handleDistrictChange}
                className="common-input form-select"
              >
                <option value="all">All</option>
                {DistrictName &&
                  DistrictName.map((row, id) => (
                    <option
                      key={id}
                      value={row.district_code}
                      className="text-dark"
                    >
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {props.role == 6 ||
          props.role == 7 ||
          props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3  mx-2">
              <label className="form-label">{t("Block")} </label>
              <select
                name="Block"
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="all">All</option>
                {Allblocks &&
                  Allblocks.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {props.role == 5 ||
          props.role == 6 ||
          props.role == 7 ||
          props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label className="form-label">{t("School")} </label>
              <select
                name="SchoolName"
                className="common-input form-select"
                onChange={handleSchoolName}
                required
              >
                <option value="all">All</option>
                {AllSchoolNames &&
                  AllSchoolNames.map((row, index) => (
                    <option value={row.school_id}>{row.school_name}</option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {/* <div className="col-md-2 mx-2">
            <label className="form-label">{t("Hostel Type")} </label>
            <select
              name="HostelType"
              className="common-input form-select"
              onChange={handleHostelType}
              required
            >
              <option value="all">All</option>
              {AllHostelTypes &&
                AllHostelTypes.map((row, index) => (
                  <option value={row.hostel_id}>{row.hostel_type}</option>
                ))}
            </select>
          </div>
          <div className="col-md-2 mx-2">
            <label className="form-label">{t("Amenity Type")} </label>
            <select
              name="AmenityType"
              className="common-input form-select"
              onChange={handleAssetsType}
              required
            >
              <option value="all">All</option>
              {AssetsTypes &&
                AssetsTypes.map((row, index) => (
                  <option value={row.amenity_id}>{row.name}</option>
                ))}
            </select>
          </div> */}

          {props.role == 4 ? (
            ""
          ) : (
            <button
              className="btn btn-primary btn-sm  mx-2"
              style={{ marginTop: "28px" }}
              onClick={getSchoolCardsData}
            >
              {t("Search")}
            </button>
          )}
        </div>
      </div>
      <div className="my-3 col-12 d-flex align-items-center justify-content-between">
        <div className="col-md-3 mx-1">
          <div className="card card2">
            <div className="card-body hello2">
              <h6 className="text-white">{t("Total")}</h6>
              <h3 className="card-title text-white">{t("Schools")}</h3>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {schools > 0 ? schools : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello3">
              <h6 className="text-white">{t("Total")}</h6>
              <h3 className="card-title text-white">{t("Hostels")}</h3>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {hostels > 0 ? hostels : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card1">
            <div className="card-body hello1">
              <h6 className="text-white">{t("Total")}</h6>
              <h3 className="card-title text-white">{t("Students")}</h3>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {students > 0 ? students : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello4">
              <h6 className="text-white">{t("Total")}</h6>
              <h3 className="card-title text-white">{t("Teachers")}</h3>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {staffcount > 0 ? staffcount : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 row d-flex justify-content-around">
        <h3 className="text-dark my-4 col-12">{t("Staff")}</h3>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(staffOptions, staffOptionsCheck)}
        </div>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(otherStaffOptions, otherStaffOptionsCheck)}
        </div>

        <h3 className="text-dark my-4 col-12">{t("Student")}</h3>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(girlsBoysOptions, girlsBoysOptionsCheck)}
        </div>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(categoryOptions, categoryOptionsCheck)}
        </div>

        {props.role == 4 ? (
          ""
        ) : (
          <>
            <h3 className="text-dark my-4 col-6">
              {t("Residential & Non-Residential")}
            </h3>
            <h3 className="text-dark my-4 col-6">{t("Type of School")}</h3>
            <div className="col-6 d-flex justify-content-center align-items-center">
              {renderChart(resOptions, resOptionsCheck)}
            </div>
            <div className="col-6 d-flex justify-content-center align-items-center">
              {renderChart(schoolTypeOptions, schoolTypeOptionsCheck)}
            </div>
          </>
        )}
        <h3 className="text-dark my-4 col-12">{t("No. of Hostels")}</h3>
        <h3 className="text-dark my-4 col-6 text-center">
          {t(" - By School Management Category")}
        </h3>
        <h3 className="text-dark my-4 col-6 text-center">
          {t(" - By Sanctioned Capacity")}
        </h3>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(hostel1Options, hostel1OptionsCheck)}
        </div>
        <div className="col-6 d-flex justify-content-center align-items-center">
          {renderChart(hostel2Options, hostel2OptionsCheck)}
        </div>
      </div>
    </div>
  );
};

export default SchoolCards;
